/** A website address typed without "https://" (the founder, 2026-10-16; DECISIONS "2026-10-16 — A bare address gets https://"): every field
 *  that asks for a web address, in the web app (on blur and on submit) and in the API's schemas, runs the text through `withHttps` first, so
 *  "kriesi.at" works. The field's own check still decides what is valid: http stays http and is refused where only https is allowed. Pure. */

/** "<scheme>:" at the start; a colon followed by a digit is a port ("kriesi.at:8443"), not a scheme */
const HAS_SCHEME = /^[a-z][a-z0-9+.-]*:(?!\d)/i;

/** The text trimmed; when it carries no scheme and looks like a host (no space, not a path, a dot before any path), "https://" in front. Anything
 *  else comes back trimmed and unchanged, so an empty field stays empty and "my docs site" or "/privacy" is still refused by the field. */
export function withHttps(text: string): string {
  const t = text.trim();
  if (!t || /\s/.test(t) || t.startsWith("/") || HAS_SCHEME.test(t)) return t;
  const host = t.split(/[/:?#]/, 1)[0]!;
  return host.includes(".") ? `https://${t}` : t;
}
